module.exports = __webpack_public_path__ + "img/5f_r_goodsmile@2x.0cf208d4.jpg";